import { ThemedText } from "@/components/themed-text";
import { BrandButton } from "@/components/ui/brand-button";
import { BrandColors } from "@/constants/theme";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, View } from "react-native";

interface EmptyStateProps {
  icon?: keyof typeof Ionicons.glyphMap;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  icon = "folder-open-outline",
  title,
  subtitle,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Ionicons name={icon} size={48} color={BrandColors.primary} />
      </View>
      <ThemedText style={styles.title} type="subtitle">
        {title}
      </ThemedText>
      {subtitle ? (
        <ThemedText style={styles.subtitle} type="small">
          {subtitle}
        </ThemedText>
      ) : null}
      {actionLabel && onAction ? (
        <BrandButton onPress={onAction} style={styles.button}>
          {actionLabel}
        </BrandButton>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 80,
    paddingHorizontal: 24,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: BrandColors.primary + "15",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
  },
  title: {
    textAlign: "center",
    marginBottom: 8,
  },
  subtitle: {
    textAlign: "center",
    color: BrandColors.mediumGray,
    marginBottom: 16,
  },
  button: {
    marginTop: 8,
    minWidth: 160,
  },
});
